import React, { Component, Fragment } from 'react';
import moment from 'moment';

import {
  IRPFData,
  Section,
  TitleSection,
  TooltipElement,
  AccordionDataSection,
  Button
} from '../../../views/Employee/FiscalData/IRPFData';
import {
  UploadConfirm,
  BankAccountModal as CancelModal
} from '../../../views/Employee/FiscalData';
import { IRPFForm } from '../../../views/Employee/FiscalData/IRPFData/irpfForm';
import { ParentsForm } from '../../../views/Employee/FiscalData/IRPFData/parentsForm';
import { ChildrensForm } from '../../../views/Employee/FiscalData/IRPFData/childrensForm';
import Icon from '../../../core/Icon';
import { Plus } from '../../../../../assets/images/index';

import { StatusMessage } from './common';
import Loading from '../../../core/Loading';

import { IRPFDataTxts } from '../../../../constants/irpf';

import {
  getIRPFDataFromChangeRequest,
  getIRPFData,
  deleteIRPFStatusChangeRequest,
  deleteIRPFFamilyStatusChangeRequest,
  createIRPFStatusChangeRequest,
  editIRPFStatusChangeRequest,
  createFamStatusChangeRequest,
  editFamStatusChangeRequest
} from '../../../../utils/apiFiscalData';

import {
  StyledAlignRight,
  StyledButtonPlus,
  StatusMessageWrapper,
  ParentContainer
} from './style';

const getFormattedTxt = txt => (txt === 'S' ? 'Sí' : 'No');
const getCivilStatus = irpfStatus => {
  switch (irpfStatus) {
    case 'SINGLE_SEPARATED_DIVORCED_WIDOWED':
      return 'Soltero/a';
    case 'MARRIED':
      return 'Casado/a';
    case 'OTHERS':
      return 'Otras/No desea manifestarla';
    default:
      return '';
  }
};
// eslint-disable-next-line consistent-return
const getLastFamilyNumber = list => {
  if (list.length > 0) {
    return list.sort((a, b) => a.familyNumber - b.familyNumber)[list.length - 1]
      .familyNumber;
  }
};

class IRPFSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'Resume',
      isLoading: true,
      cancelling: false,
      cancellingIRPFStatusChangeRequest: false,
      cancellingFamStatusChangeRequest: false,
      irpfStatus: null,
      editedIRPFStatus: null,
      childrens: [],
      editedChildrens: [],
      editFamStatusMode: false,
      parents: [],
      editedParents: [],
      currentFamilyNumber: null,
      currentFamilyRelated: null,
      onErrorLoadData: false,
      lastFamilyNumber: 0
    };
  }

  componentDidMount() {
    getIRPFData()
      .then(irpfData => {
        this.setIRPFData(irpfData);

        getIRPFDataFromChangeRequest()
          .then(changeRequest => {
            const { irpfStatus, famStatusList } = changeRequest;

            if (irpfStatus) {
              this.setEditedIRPFStatus(irpfStatus);
            }

            if (famStatusList.length) {
              this.setEditedFamStatus(famStatusList);
            }
          })
          .catch(error => {
            throw error;
          });
      })
      .catch(error => {
        this.setState({
          onErrorLoadData: true
        });
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  }

  setIRPFData = irpfData => {
    const { lastFamilyNumber, editedChildrens, editedParents } = this.state;
    const { irpfStatus, famStatusList } = irpfData;
    const famStatusListUpdated = this.setFamStatusLists(famStatusList);
    const { descendents, ascendants, all } = famStatusListUpdated;
    const lastFamilyNumberUpdated =
      !editedChildrens.length && !editedParents.length
        ? getLastFamilyNumber(all)
        : lastFamilyNumber;

    this.setState({
      lastFamilyNumber: lastFamilyNumberUpdated,
      irpfStatus,
      childrens: descendents,
      parents: ascendants
    });
  };

  setEditedIRPFStatus = irpfStatus => {
    this.setState({
      editedIRPFStatus: irpfStatus
    });
  };

  setEditedFamStatus = famStatusList => {
    const editedFamList = this.setFamStatusLists(famStatusList);
    const { descendents, ascendants, all } = editedFamList;
    const lastFamilyNumberUpdated = getLastFamilyNumber(all);

    this.setState({
      lastFamilyNumber: lastFamilyNumberUpdated,
      editedChildrens: descendents,
      editedParents: ascendants
    });
  };

  setFamStatusLists = famStatusList => {
    const descendents = [];
    const ascendants = [];

    famStatusList.forEach(item => {
      if (item.related === 'DESCENDANT') {
        descendents.push(item);
      }
      if (item.related === 'ASCENDANT') {
        ascendants.push(item);
      }
    });

    return {
      descendents,
      ascendants,
      all: [...descendents, ...ascendants]
    };
  };

  setPage = page => {
    this.setState({ page });
  };

  uploadIRPFStatus = irpfStatus => {
    const { editedIRPFStatus } = this.state;
    const serviceSelected = editedIRPFStatus
      ? editIRPFStatusChangeRequest
      : createIRPFStatusChangeRequest;

    this.setState({
      isLoading: true
    });

    serviceSelected(irpfStatus)
      .then(() => {
        this.setState({
          page: 'Confirm',
          editedIRPFStatus: irpfStatus
        });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  uploadFamStatus = (famStatus, editing) => {
    const { editedChildrens, editedParents } = this.state;
    let editedFamStatusObj = null;

    this.setState({
      isLoading: true
    });

    if (famStatus.related === 'DESCENDANT') {
      editedFamStatusObj = {
        type: 'editedChildrens',
        value: editedChildrens
      };
    } else {
      editedFamStatusObj = {
        type: 'editedParents',
        value: editedParents
      };
    }

    if (editing) {
      this.editFamStatus(famStatus, editedFamStatusObj);
    } else {
      this.createFamStatus(famStatus, editedFamStatusObj);
    }
  };

  createFamStatus = (famStatus, editedFamStatusObj) => {
    const { lastFamilyNumber } = this.state;
    const { type, value } = editedFamStatusObj;
    const editedFamStatusUpdated = [...value, famStatus];

    createFamStatusChangeRequest(famStatus)
      .then(() => {
        this.setState({
          page: 'Confirm',
          [type]: editedFamStatusUpdated,
          lastFamilyNumber: lastFamilyNumber + 1
        });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  editFamStatus = (famStatus, editedFamStatusObj) => {
    const { type, value } = editedFamStatusObj;
    const editedFamStatusUpdated = [...value];
    const currentIndex = editedFamStatusUpdated.findIndex(
      item => item.familyNumber === famStatus.familyNumber
    );

    editedFamStatusUpdated[currentIndex] = famStatus;

    editFamStatusChangeRequest(famStatus)
      .then(() => {
        this.setState({
          page: 'Confirm',
          [type]: editedFamStatusUpdated
        });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  showCancelIRPFStatusChangeRequestModal = () => {
    this.setState({
      cancellingIRPFStatusChangeRequest: true
    });
  };

  showCancelFamStatusChangeRequestModal = (familyNumber, related) => {
    this.setState({
      cancellingFamStatusChangeRequest: true,
      currentFamilyNumber: familyNumber,
      currentFamilyRelated: related
    });
  };

  cancelIRPFStatusChangeRequest = () => {
    this.setState({
      isLoading: true
    });

    deleteIRPFStatusChangeRequest().then(() => {
      this.setState({
        cancellingIRPFStatusChangeRequest: false,
        editedIRPFStatus: null,
        isLoading: false
      });
    });
  };

  cancelFamilyStatusChangeRequest = () => {
    const {
      editedChildrens,
      editedParents,
      currentFamilyNumber,
      currentFamilyRelated,
      lastFamilyNumber
    } = this.state;
    let editedFamStatusObj = null;

    this.setState({
      isLoading: true
    });

    deleteIRPFFamilyStatusChangeRequest(currentFamilyNumber).then(() => {
      if (currentFamilyRelated === 'DESCENDANT') {
        editedFamStatusObj = {
          type: 'editedChildrens',
          value: editedChildrens.filter(
            item => item.familyNumber !== currentFamilyNumber
          )
        };
      } else {
        editedFamStatusObj = {
          type: 'editedParents',
          value: editedParents.filter(
            item => item.familyNumber !== currentFamilyNumber
          )
        };
      }

      this.setState({
        cancellingFamStatusChangeRequest: false,
        [editedFamStatusObj.type]: editedFamStatusObj.value,
        isLoading: false,
        currentFamilyNumber: null,
        currentFamilyRelated: null,
        lastFamilyNumber: lastFamilyNumber - 1
      });
    });
  };

  editFamStatusChangeRequest = request => {
    const { related, familyNumber } = request;

    this.setPage(
      related === 'DESCENDANT' ? 'EditChildrenStatus' : 'EditParentStatus'
    );

    this.setState({
      editFamStatusMode: true,
      currentFamilyNumber: familyNumber
    });
  };

  cancelChangeRequest = () => {
    this.setState({
      cancelling: false
    });
  };

  getRender = () => {
    const {
      page,
      cancelling,
      cancellingIRPFStatusChangeRequest,
      cancellingFamStatusChangeRequest,
      irpfStatus,
      editedIRPFStatus,
      childrens,
      editedChildrens,
      parents,
      editedParents,
      editFamStatusMode,
      onErrorLoadData,
      currentFamilyNumber,
      lastFamilyNumber
    } = this.state;

    const { cancel } = this.props;

    if (onErrorLoadData) {
      return <p>Lo sentimos, pero no existen datos para su usuario</p>;
    }

    return (
      <IRPFData>
        {page === 'Resume' && (
          <Fragment>
            <StatusMessageWrapper>
              {editedIRPFStatus && (
                <StatusMessage
                  text={IRPFDataTxts.pending.irpf}
                  onEdit={() => {
                    this.setPage('EditIRPFStatus');
                  }}
                  onDelete={this.showCancelIRPFStatusChangeRequestModal}
                />
              )}
              {editedChildrens.length || editedParents.length
                ? [...editedChildrens, ...editedParents].map(item => (
                    <StatusMessage
                      text={IRPFDataTxts.pending[item.related]}
                      onEdit={() => {
                        this.editFamStatusChangeRequest(item);
                      }}
                      onDelete={() =>
                        this.showCancelFamStatusChangeRequestModal(
                          item.familyNumber,
                          item.related
                        )
                      }
                    />
                  ))
                : null}
            </StatusMessageWrapper>
            <Section>
              <TitleSection>
                <TooltipElement text={IRPFDataTxts.resume.titleFamily} />
              </TitleSection>
              {irpfStatus.civilStatus && (
                <AccordionDataSection
                  title={IRPFDataTxts.label.estadoCivil}
                  body={getCivilStatus(irpfStatus.civilStatus)}
                  span={1}
                />
              )}
              {irpfStatus.spouseNif && (
                <AccordionDataSection
                  title={IRPFDataTxts.label.nifConyuge}
                  body={irpfStatus.spouseNif}
                  span={0}
                />
              )}
              {irpfStatus.dateGeographicalMobility && (
                <AccordionDataSection
                  title={IRPFDataTxts.label.movilidadGeo}
                  body={irpfStatus.dateGeographicalMobility ? 'Sí' : 'No'}
                  span={0}
                />
              )}
              {irpfStatus.workLonger && (
                <AccordionDataSection
                  title={IRPFDataTxts.label.prolongacionActividad}
                  body={getFormattedTxt(irpfStatus.workLonger)}
                  span={1}
                />
              )}
              {irpfStatus.purchaseRenovationMainResidence && (
                <AccordionDataSection
                  title={IRPFDataTxts.label.pagosVivienda}
                  body={getFormattedTxt(
                    irpfStatus.purchaseRenovationMainResidence
                  )}
                  span={2}
                />
              )}
            </Section>
            <StyledAlignRight>
              <Button
                secondary
                fixed
                onClick={() => cancel()}
                disabled={editedIRPFStatus}
              >
                {IRPFDataTxts.resume.backBtn}
              </Button>
              <Button
                secondary
                fixed
                onClick={() => this.setPage('EditIRPFStatus')}
                disabled={editedIRPFStatus}
              >
                {IRPFDataTxts.resume.btn}
              </Button>
            </StyledAlignRight>
            <Section>
              <TitleSection>
                <TooltipElement text={IRPFDataTxts.resume.titleChilds} />
                <StyledButtonPlus
                  dark
                  onClick={() => {
                    this.setPage('EditChildrenStatus');
                    this.setState({
                      editFamStatusMode: false
                    });
                  }}
                >
                  <Icon color="light" size="xs" svg={Plus} />
                </StyledButtonPlus>
              </TitleSection>
              {childrens.length ? (
                childrens.map(item => {
                  const {
                    birthDate,
                    dateAdoption,
                    endDate,
                    name,
                    surname1,
                    surname2,
                    gender,
                    computoPorEntero,
                    deathChild
                  } = item;
                  return (
                    <ParentContainer>
                      {birthDate && (
                        <AccordionDataSection
                          title="Fecha de nacimiento"
                          body={moment(birthDate).format('DD/MM/YYYY')}
                          span={0}
                        />
                      )}
                      {dateAdoption && (
                        <AccordionDataSection
                          title="Fecha de adopción"
                          body={moment(dateAdoption).format('DD/MM/YYYY')}
                          span={endDate ? 0 : 1}
                        />
                      )}
                      {endDate && (
                        <AccordionDataSection
                          title="Fecha de finalización"
                          body={moment(endDate).format('DD/MM/YYYY')}
                          span={0}
                        />
                      )}
                      {name && (
                        <AccordionDataSection
                          title="Nombre"
                          body={name}
                          span={0}
                        />
                      )}
                      {surname1 && (
                        <AccordionDataSection
                          title="1er Apellido"
                          body={surname1}
                          span={0}
                        />
                      )}
                      {surname2 && (
                        <AccordionDataSection
                          title="2º Apellido"
                          body={surname2}
                          span={0}
                        />
                      )}
                      {gender && (
                        <AccordionDataSection
                          title="Sexo"
                          body={gender}
                          span={0}
                        />
                      )}
                      {computoPorEntero && (
                        <AccordionDataSection
                          title="Cómputo x entero"
                          body={computoPorEntero}
                          span={0}
                        />
                      )}
                      {deathChild && (
                        <AccordionDataSection
                          title="Fallecimiento"
                          body={deathChild}
                          span={0}
                        />
                      )}
                    </ParentContainer>
                  );
                })
              ) : (
                <AccordionDataSection
                  body="No tiene descencientes registrados"
                  span={0}
                />
              )}
            </Section>
            <Section>
              <TitleSection>
                <TooltipElement text={IRPFDataTxts.resume.titleParents} />
                <StyledButtonPlus
                  dark
                  onClick={() => {
                    this.setPage('EditParentStatus');
                    this.setState({
                      editFamStatusMode: false
                    });
                  }}
                >
                  <Icon color="light" size="xs" svg={Plus} />
                </StyledButtonPlus>
              </TitleSection>
              {parents.length > 0 ? (
                parents.map(item => {
                  const {
                    birthDate,
                    name,
                    surname1,
                    surname2,
                    gender,
                    computoPorEntero
                  } = item;

                  return (
                    <ParentContainer>
                      {birthDate && (
                        <AccordionDataSection
                          title="Fecha nacimiento"
                          body={moment(birthDate).format('DD/MM/YYYY')}
                          span={0}
                        />
                      )}
                      {name && (
                        <AccordionDataSection
                          title="Nombre"
                          body={name}
                          span={0}
                        />
                      )}
                      {surname1 && (
                        <AccordionDataSection
                          title="1er Apellido"
                          body={surname1}
                          span={0}
                        />
                      )}
                      {surname2 && (
                        <AccordionDataSection
                          title="2º Apellido"
                          body={surname2}
                          span={0}
                        />
                      )}
                      {gender && (
                        <AccordionDataSection
                          title="Sexo"
                          body={gender}
                          span={0}
                        />
                      )}
                      {computoPorEntero && (
                        <AccordionDataSection
                          title="Cómputo x entero"
                          body={computoPorEntero}
                          span={0}
                        />
                      )}
                    </ParentContainer>
                  );
                })
              ) : (
                <AccordionDataSection
                  body="No tiene ascendientes registrados."
                  span={1}
                />
              )}
            </Section>
          </Fragment>
        )}
        {page === 'EditIRPFStatus' && (
          <Fragment>
            <IRPFForm
              initialData={editedIRPFStatus || irpfStatus}
              onSend={this.uploadIRPFStatus}
              onCancel={() =>
                this.setState({
                  page: 'Resume'
                })
              }
            />
          </Fragment>
        )}
        {page === 'EditParentStatus' && (
          <Fragment>
            <ParentsForm
              currentFamilyNumber={currentFamilyNumber}
              lastFamilyNumber={lastFamilyNumber}
              initialData={
                editedParents.length && editFamStatusMode
                  ? editedParents.find(
                      item => item.familyNumber === currentFamilyNumber
                    )
                  : null
              }
              onSend={this.uploadFamStatus}
              onCancel={() =>
                this.setState({
                  page: 'Resume'
                })
              }
              editMode={editFamStatusMode}
            />
          </Fragment>
        )}
        {page === 'EditChildrenStatus' && (
          <Fragment>
            <ChildrensForm
              currentFamilyNumber={currentFamilyNumber}
              lastFamilyNumber={lastFamilyNumber}
              initialData={
                editedChildrens.length && editFamStatusMode
                  ? editedChildrens.find(
                      item => item.familyNumber === currentFamilyNumber
                    )
                  : null
              }
              onSend={this.uploadFamStatus}
              onCancel={() =>
                this.setState({
                  page: 'Resume'
                })
              }
              editMode={editFamStatusMode}
            />
          </Fragment>
        )}
        {page === 'Confirm' && (
          <UploadConfirm
            onClick={() =>
              this.setState({
                page: 'Resume'
              })
            }
            title={IRPFDataTxts.confirm.title}
            txt={IRPFDataTxts.confirm.txt}
          />
        )}
        {cancelling && (
          <CancelModal
            onCancel={() =>
              this.setState({
                cancelling: false
              })
            }
            onAccept={() => {
              this.cancelChangeRequest();
            }}
          />
        )}
        {cancellingIRPFStatusChangeRequest && (
          <CancelModal
            onCancel={() =>
              this.setState({
                cancellingIRPFStatusChangeRequest: false
              })
            }
            onAccept={() => {
              this.cancelIRPFStatusChangeRequest();
            }}
          />
        )}
        {cancellingFamStatusChangeRequest && (
          <CancelModal
            onCancel={() =>
              this.setState({
                cancellingFamStatusChangeRequest: false
              })
            }
            onAccept={() => {
              this.cancelFamilyStatusChangeRequest();
            }}
          />
        )}
      </IRPFData>
    );
  };

  render() {
    const { isLoading } = this.state;

    return isLoading ? <Loading /> : this.getRender();
  }
}

export default IRPFSection;
